<template>
    <div>
        <vue-form class="form-horizontal form-validation" :state="formstate" @submit.prevent="onSubmit">
            <b-row class='toolbar-ptc'>
                <b-col>
                    <router-link :to="{ name: 'coupon_exchange_list', params: { queryTab0: $route.params.queryTab0, querySaleNow: $route.params.querySaleNow, querySaleSchedule: $route.params.querySaleSchedule, queryTab1: $route.params.queryTab1, queryTab2: $route.params.queryTab2, collapse: $route.params.collapse, modelTab: $route.params.modelTab } }" class="btn btn-ptc1" tag="button">返回</router-link>
                </b-col>
                <b-col class='text-center title'>點數兌換券上架 / 商品券上架 / 新增</b-col>
                <b-col class='text-right'>
                    <button type="submit" class="btn btn-save">儲存</button>
                </b-col>
            </b-row>
            <div id="func-content">
                <div class='contact-page'>
                    <div class='col-lg-12'>
                        <b-card class='bg-warning-card'>
                            <div class='row'>
                                <b-container fluid>
                                    <form>
                                        <div class='row mb-3'>
                                            <label class='control-label col-md-3'>上傳圖片：</label>
                                            <div class='col-md-7'>
                                                <input type='file' class='upload_input form-control' id='pic' multiple @change='handleFileChange' accept="image/*" ref='inputer'>
                                                <label class='upload_block' for='pic'>
                                                    <span class='upload_icon'>➕</span>
                                                    <img class='upload_img' v-if="dataUrl != undefined" :src='dataUrl' />
                                                </label>
                                                <div class="text-danger" style="padding: 0.3rem" v-if="v_dataUrlMsg != ''">{{v_dataUrlMsg}}</div>
                                                <div class='text-red' style='color:#FF0000;'>※限制上傳一張圖片，建議尺寸為156x156，內容建議顯示於寬x高120x156</div>
                                            </div>
                                        </div>
                                        <div class='row mb-3'>
                                              <label class='control-label col-md-3'>是否為贈卷用：</label>
                                              <div class='col-md-9'>
                                                <toggle-button v-model="appSwap" :sync="true" :height=30 :width=60
                                                style="font-size: 14px;" :labels="{checked: '否', unchecked: '是'}" :color="{checked: '#dc6460', unchecked: '#09BD8F'}" @change="onChangeAppSwap"/>
                                              </div>
                                        </div>
                                        <div class='row mb-3'>
                                          <label class='control-label col-md-3'>允許會員互相轉贈：</label>
                                          <div class='col-md-9'>
                                            <toggle-button
                                              v-model="allowTransfer"
                                              :height="30"
                                              :width="60"
                                              style="font-size: 14px;"
                                              :labels="{ checked: '是', unchecked: '否' }"
                                              :color="{ checked: '#09BD8F', unchecked: '#dc6460' }"
                                            />
                                          </div>
                                        </div>
                                        <div class='row mb-3' v-show="appSwap==true">
                                            <label class='control-label col-md-3'>APP分類：</label>
                                            <div class='col-md-7'>
                                                    <select id='AppType' name='AppType' class='form-control' v-model='AppType' >
                                                        <option disabled value='0'>請選擇</option>
                                                        <option v-for='x in ListAppType' v-bind:value='x.id' :key='x.id'>{{x.name}}</option>
                                                    </select>
                                                    <div class="text-danger" style="padding: 0.3rem" v-if="v_AppType != ''">{{v_AppType}}</div>
                                            </div>
                                        </div>
                                        <div class='row mb-3'>
                                            <label class='control-label col-md-3'>票券名稱：</label>
                                            <div class='col-md-7'>
                                                <validate tag="div">
                                                    <input type='text' name='Input_TicketName' class='form-control' v-model.trim='TicketName' placeholder='請輸入票券名稱' maxlength="30" required>
                                                    <field-messages name="Input_TicketName" show="$invalid && $submitted" class="text-danger">
                                                        <div slot="required">請輸入票券名稱</div>
                                                    </field-messages>
                                                </validate>
                                            </div>
                                        </div>
                                        <div class='row mb-3'>
                                            <label class='control-label col-md-3'>票券類別：</label>
                                            <div class='col-md-7'>
                                                <validate tag="div">
                                                    <select id='select_TicketType' name='select_TicketType' class='form-control' v-model='TicketType' @change="onTicketTypeChange" required>
                                                        <option disabled value=''>請選擇</option>
                                                        <option v-for='x in ListTicketType' v-bind:value='x.code+x.sn' :key='x.code+x.sn'>{{x.name}}</option>
                                                    </select>
                                                    <field-messages name="select_TicketType" show="$invalid && $submitted" class="text-danger">
                                                        <div slot="required">請選擇票券類別</div>
                                                    </field-messages>
                                                </validate>
                                            </div>
                                        </div>
                                        <div class='row mb-3'>
                                            <label class='control-label col-md-3'>發行型態：</label>
                                            <div class='col-md-7'>
                                                <table>
                                                    <tr>
                                                        <td>
                                                            <input type='radio' name='rdoGroup' value=1 v-model='TicketPublished' @change="isFree = false">
                                                            <label for='TicketPublished1' v-show="appSwap==false" >常態</label>
                                                            <label for='TicketPublished1' v-show="appSwap==true" >票券有效天數</label>
                                                        </td>
                                                        <td>
                                                            <validate>
                                                                <input :disabled='TicketPublished != 1' type='number' name="Input_TicketPublishedDay" class='form-control' style='width:100' value=30 min=0 max=99999  v-on:input="TicketPublishedDay = validNumberLen($event, 5)" placeholder='請輸入兌換後可使用天數' v-model='TicketPublishedDay' :required='this.TicketPublished == 1'>
                                                                <field-messages name="Input_TicketPublishedDay" show="$invalid && $submitted" class="text-danger">
                                                                <div v-if='this.v_TicketPublishedDayMsg == ""' slot="required">請輸入天數</div>
                                                            </field-messages>
                                                            <div class="text-danger" style="padding: 0.3rem" v-show="TicketPublished == 1 && this.v_TicketPublishedDayMsg != ''">{{this.v_TicketPublishedDayMsg}}</div>
                                                            </validate>
                                                        </td>
                                                        <td>
                                                            <label class='control-label'>天</label>
                                                            <!-- <span class="text-danger" style="padding: 0.3rem" v-if="TicketPublished === 1 && (TicketPublishedDay === '' || TicketPublishedDay === 0)">請輸入兌換後可使用天數</span><span else></span> -->
                                                        </td>
                                                    </tr>
                                                    <tr v-show="appSwap==true">
                                                        <td>
                                                            <input type='radio' name='rdoGroup' value=2 v-model='TicketPublished'>
                                                            <label for='TicketPublished2'>限量</label>
                                                        </td>
                                                        <td>
                                                            <validate>
                                                                <input :disabled='TicketPublished !=2' type='number' name="Input_TicketPublishedQty" class='form-control' placeholder='請輸入限量張數' min=0 max=99999 v-on:input="TicketPublishedQty = validNumberLen($event, 5)" v-model='TicketPublishedQty' :required='this.TicketPublished == 2'>
                                                                <field-messages name="Input_TicketPublishedQty" show="$invalid && $submitted" class="text-danger">
                                                                <div v-if='this.v_TicketPublishedQtyMsg==""' slot="required">請輸入張數</div>
                                                            </field-messages>
                                                            <div class="text-danger" style="padding: 0.3rem" v-show="TicketPublished == 2 && this.v_TicketPublishedQtyMsg != ''">{{this.v_TicketPublishedQtyMsg}}</div>
                                                            </validate>
                                                        </td>
                                                        <td>
                                                            <label class='control-label' style="padding-right:20px">張 (販售總數)</label>
                                                        </td>
                                                        <td >
                                                            <label class='control-label'>免費</label>
                                                            <toggle-button :disabled="TicketPublished != 2" v-model="isFree" :width=60 :height=30 :sync="true" style="font-size: 14px;" :labels="{checked: '是', unchecked: '否'}" :color="{checked: '#09BD8F', unchecked: '#dc6460'}" @change="onChangeFree" />
                                                        </td>
                                                    </tr>
                                                    <tr v-if="TicketPublished == 2">
                                                        <td>
                                                        </td>
                                                        <td colspan='3'>
                                                          <table>
                                                            <tr>
                                                              <td colspan='3'>
                                                                <input type='radio' name='rdoLimitBuy' value=1 :disabled="TicketPublished != 2" v-model='TicketLimitBuy'>
                                                                <label>會員限兌換一次一張</label>
                                                              </td>
                                                            </tr>
                                                            <tr>
                                                              <td>
                                                                <input type='radio' name='rdoLimitBuy' value=2 :disabled="TicketPublished != 2" v-model='TicketLimitBuy'>
                                                                <label>會員每日限購</label>
                                                              </td>
                                                              <td>
                                                                <validate>
                                                                  <input :disabled='!(TicketPublished ==2 && TicketLimitBuy ==2)' type='number' class='form-control' name="Input_TicketLimitBuyQty" placeholder='請輸入限購張數' min=0 max=99999 v-on:input="TicketLimitBuyQty = validNumberLen($event, 5)" v-model='TicketLimitBuyQty' :required='this.TicketPublished == 2 && this.TicketLimitBuy == 2'>
                                                                  <field-messages name="Input_TicketLimitBuyQty" show="$invalid && $submitted" class="text-danger">
                                                                  <div v-if='this.v_TicketLimitBuyQtyMsg==""' slot="required">請輸入張數</div>
                                                                </field-messages>
                                                                <div class="text-danger" style="padding: 0.3rem" v-show="TicketPublished == 2 && TicketLimitBuy == 2 && this.v_TicketLimitBuyQtyMsg != ''">{{this.v_TicketLimitBuyQtyMsg}}</div>
                                                                </validate>
                                                              </td>
                                                              <td>
                                                                  <label class='control-label' style="padding-right:20px">張</label>
                                                              </td>
                                                            </tr>
                                                          </table>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                        <div class='row mb-3'>
                                            <label class='control-label col-md-3'>上架時間：</label>
                                            <div class='col-md-3'>
                                                <validate tag="div">
                                                    <input type='date' name='Input_sale_sdate' class='form-control' v-model='sale_sdate' @change="updateValue($event.target.value)" :min="min_sdate" :max="max_date">
                                                    <div class="text-danger" style="padding: 0.3rem" v-if="v_sale_sdate != ''">{{v_sale_sdate}}</div>
                                                    <div class="text-danger" style="padding: 0.3rem" v-if="v_SaleDate != ''">{{v_SaleDate}}</div>
                                                </validate>
                                            </div>
                                            <label class='control-label'></label>
                                            <div class='col-md-3'>
                                                <validate tag="div">
                                                  <input type='time' class='form-control' v-model='sale_stime'>
                                                  <div class="text-danger" style="padding: 0.3rem" v-if="v_sale_stime != ''">{{v_sale_stime}}</div>
                                                </validate>
                                            </div>
                                        </div>
                                        <div class='row mb-3'>
                                            <label class='control-label col-md-3'>下架時間：</label>
                                            <div class='col-md-3'>
                                                <validate tag="div">
                                                    <input type='date' name='Input_sale_edate' class='form-control' v-model='sale_edate' :min="min_edate" :max="max_date" @change="ResetWeek()">
                                                    <div class="text-danger" style="padding: 0.3rem" v-if="v_sale_edate != ''">{{v_sale_edate}}</div>
                                                </validate>
                                            </div>
                                            <label class='control-label'></label>
                                            <div class='col-md-3'>
                                              <validate tag="div">
                                                  <input type='time' class='form-control' v-model='sale_etime'>
                                                  <div class="text-danger" style="padding: 0.3rem" v-if="v_sale_etime != ''">{{v_sale_etime}}</div>
                                                </validate>
                                            </div>
                                        </div>
                                        <div class='row mb-3' v-show="appSwap==true">
                                            <label class='control-label col-md-3'>上架顯示週期：</label>
                                            <div class='col-md-7'>
                                              <validate tag="div">
                                                <b-form-group>
                                                  <b-form-checkbox-group id="checkbox-group-1" v-model="week" :options="optionsWeek" name="flavour-1" ></b-form-checkbox-group>
                                                </b-form-group>
                                                <div class="text-danger" v-show="this.v_WeekMsg != ''">{{this.v_WeekMsg}}</div>
                                              </validate>
                                            </div>
                                        </div>
                                        <div class='row mb-3' v-if='TicketPublished==2'>
                                            <label class='control-label col-md-3'>兌換期間：</label>
                                            <div class='col-md-3'>
                                                <validate tag="div">
                                                    <input type='date' name='Input_use_sdate' class='form-control' v-model='use_sdate' :max="max_date" disabled :required='this.TicketPublished == 2' >
                                                    <field-messages name="Input_use_sdate" show="$invalid && $submitted" class="text-danger">
                                                        <div v-if='v_use_sdateMsg==""' slot="required">&nbsp;請選擇上架日(起)</div>
                                                    </field-messages>
                                                    <div class="text-danger" style="padding: 0.3rem" v-show="this.v_use_sdateMsg != ''">{{this.v_use_sdateMsg}}</div>
                                                    <!-- <div class="text-danger" style="padding: 0.3rem" v-if="v_UseDate === false">起始日不可大於結束日</div> -->
                                                </validate>
                                            </div>
                                            <label class='control-label'>至</label>
                                            <div class='col-md-3'>
                                                <validate tag="div">
                                                    <input type='date' name='Input_use_edate' class='form-control' v-model='use_edate' :max="max_date" :required='this.TicketPublished == 2'>
                                                    <field-messages name="Input_use_edate" show="$invalid && $submitted" class="text-danger">
                                                        <div v-if='this.v_use_edateMsg == ""' slot="required">請輸入正確的日期格式(迄)</div>
                                                    </field-messages>
                                                    <div class="text-danger" style="padding: 0.3rem" v-show="this.v_use_edateMsg != ''">{{this.v_use_edateMsg}}</div>
                                                </validate>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class='row mb-3'>
                                            <label class='control-label col-md-3'>兌換規則：</label>
                                            <div class='col-md-9'>
                                                <table>
                                                    <tr>
                                                        <td v-show="appSwap==true">
                                                            <label class='control-label'>兌換點數</label>
                                                        </td>
                                                        <td v-show="appSwap==true">
                                                                <input type='number' :disabled="isFree && TicketPublished==2" name="Input_Point" class='form-control' min=0 max=99999 v-on:input="Point = validNumberLen($event, 5)" v-model='Point'>
                                                            <div class="text-danger" style="padding: 0.3rem" v-show="this.v_PointMsg != ''">{{this.v_PointMsg}}</div>
                                                        </td>
                                                        <td v-if="TicketType.substr(0,3) == 'A01' || TicketType.substr(0,3) == 'C01'">
                                                            <label v-if='TicketType.substr(0,3) === "A01"' class='control-label'>折抵</label>
                                                            <label v-if='TicketType.substr(0,3) === "C01"' class='control-label'>折扣</label>
                                                        </td>
                                                        <td v-if="TicketType.substr(0,3) != 'G01' && TicketType.substr(0,3) != ''">
                                                            <validate tag="div">
                                                                <input v-if='TicketType.substr(0,3) != "G01"' type='number' name="Input_SaleMoney" min=0 :max='TicketType.substr(0,3)=="C01"?1 : 9999' class='form-control' v-model='SaleMoney' v-on:input="SaleMoney = validNumberLen($event, 4)" :required='this.TicketType.substr(0,3) != "G01"'>
                                                                <field-messages name="Input_SaleMoney" show="$invalid && $submitted" class="text-danger">
                                                                    <div v-if='v_SaleMoneyMsg==""' slot="required">請輸入折扣</div>
                                                                </field-messages>
                                                            <div class="text-danger" style="padding: 0.3rem" v-show="this.v_SaleMoneyMsg != ''">{{this.v_SaleMoneyMsg}}</div>
                                                            </validate>
                                                        </td>
                                                        <td v-if="TicketType.substr(0,3) == 'G01'">
                                                            <input type='text' name="Input_ActiveName" class='form-control' v-model.trim='activeName' maxlength="30" placeholder='請輸入兌換活動'>
                                                        </td>
                                                        <td v-if="TicketType.substr(0,3) != ''">
                                                            <label v-if='TicketType.substr(0,3) === "A01"' class='control-label'>元</label>
                                                            <label v-if='TicketType.substr(0,3) === "C01"' class='control-label'>EX:9折=0.9</label>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                        <div class='row mb-3'>
                                            <label class='control-label col-md-3'>票券使用管道：</label>
                                            <div class='col-md-9'>
                                              <input type='radio' name='rdoUseType' value=1 v-model='UseType' :disabled="TicketType.substr(0,3)=='C01'">
                                              <label>全部</label>
                                              <input type='radio' name='rdoUseType' value=2 v-model='UseType' :disabled="TicketType.substr(0,3)=='C01'">
                                              <label>POS</label>
                                              <input type='radio' name='rdoUseType' value=3 v-model='UseType'>
                                              <label>APP</label>
                                            </div>
                                        </div>
                                        <div class='row mb-3' v-if="TicketType.substr(0,3)=='G01'">
                                            <label class='control-label col-md-3'>票券使用品牌：</label>
                                            <div class='col-md-4'>
                                              <select
                                                id="queryBrandsCode"
                                                name="queryBrandsCode"
                                                class="form-control"
                                                v-model="queryBrandsCode"
                                                @change="onQueryBrandsCodeChange"
                                              >
                                              <option
                                                v-for="x in selectListBrands"
                                                v-bind:value="x.Code"
                                                :key="x.Code"
                                              >{{x.Text}}</option>
                                              </select>
                                            </div>
                                        </div>
                                        <div class='row mb-3' v-if="UseType!=2">
                                            <label class='control-label col-md-3'>APP線上訂餐規則：</label>
                                            <div class='col-md-9'>
                                                <table>
                                                    <tr v-if="TicketType.substr(0,3)=='G01'">
                                                        <td>
                                                            <label class='control-label'>優惠規則</label>
                                                        </td>
                                                        <td>
                                                          <validate tag="div">
                                                              <select id='Input_TicketRule' name='Input_TicketRule' class='form-control' v-model='TicketRule' @change="checkSaleDiscount(false)" required>
                                                                  <option disabled value=''>請選擇</option>
                                                                  <option value='1'>買A送B</option>
                                                                  <option value='2'>商品折價</option>
                                                                  <option value='3'>商品特價</option>
                                                                  <option value='4'>商品第二件N折</option>
                                                              </select>
                                                              <field-messages name="Input_TicketRule" show="$invalid && $submitted" class="text-danger">
                                                                  <div slot="required">請選擇優惠規則</div>
                                                              </field-messages>
                                                          </validate>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="TicketType.substr(0,3)=='G01' && TicketRule!=''">
                                                        <td>
                                                            <label class='control-label'>買</label>
                                                        </td>
                                                        <td>
                                                          <multiselect v-model="product_A" :options="productsA" :multiple="false" :custom-label="nameWithLang" group-values="Detail" :show-labels="false" group-label="Attribute" :group-select="false" placeholder="請選擇" track-by="Name" label="Name">
                                                            <span slot="noResult">查無資料</span>
                                                          </multiselect>
                                                          <div class="text-danger" v-if="this.TicketType.substr(0,3)=='G01' && (this.TicketRule== '2' || this.TicketRule=='3' || this.TicketRule=='4') && !this.product_A && this.v_Product_A != ''">{{v_Product_A}}</div>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="TicketType.substr(0,3)=='G01' && TicketRule=='1'">
                                                        <td>
                                                          <label class='control-label'>送</label>
                                                        </td>
                                                        <td>
                                                          <multiselect v-model="product_B" :options="productsB" :multiple="false" :custom-label="nameWithLang" group-values="Detail" :show-labels="false" group-label="Attribute" :group-select="false" placeholder="請選擇" track-by="Name" label="Name">
                                                            <span slot="noResult">查無資料</span>
                                                          </multiselect>
                                                          <div class="text-danger" v-if="this.TicketType.substr(0,3)=='G01' &&this. TicketRule=='1' && (!this.product_A || !this.product_B) && this.v_Product_B != ''">{{v_Product_B}}</div>
                                                        </td>
                                                        <td><div class='text-red' style='color:#FF0000;'>※如要送加料，請選擇A商品所屬的加料品，否則B區商品將不會傳給POS。</div></td>
                                                    </tr>
                                                    <tr v-if="TicketType.substr(0,3)=='G01' && !(TicketRule=='' || TicketRule=='1')">
                                                        <td>
                                                            <label class='control-label' v-show="TicketRule=='2'">折價</label>
                                                            <label class='control-label' v-show="TicketRule=='3'">特價</label>
                                                            <label class='control-label' v-show="TicketRule=='4'">折扣</label>
                                                            <!-- <label class='control-label' v-show="TicketRule==5">滿</label> -->
                                                        </td>
                                                        <td>
                                                            <input type='number' class='form-control' name="InputSaleDiscount" placeholder='請輸入數值' min=0 :max='TicketRule=="4"?1 : 999' v-on:input="saleDiscount = validNumberLen($event, 5)" v-model='saleDiscount'>
                                                            <div class="text-danger" style="padding: 0.3rem" v-show="TicketType=='G01' && (TicketRule=='2'||TicketRule == '3'||TicketRule=='4') && this.v_SaleDiscount != ''">{{this.v_SaleDiscount}}</div>
                                                        </td>
                                                        <td>
                                                            <label class='control-label' v-show="TicketRule!='2'">元</label>
                                                            <label class='control-label' v-show="TicketRule=='4'">折 EX:9折=0.9</label>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="TicketType.substr(0,3)!='G01'">
                                                        <td>
                                                            <label class='control-label'>滿</label>
                                                        </td>
                                                        <td>
                                                              <input type='number' class='form-control' name="InputSaleDiscount" placeholder='請輸入數值' min=0 max=9999 v-on:input="useAmount = validNumberLen($event, 4)" v-model='useAmount'>
                                                              <div class="text-danger" style="padding: 0.3rem" v-show="this.v_useAmount != ''">{{this.v_useAmount}}</div>
                                                        </td>
                                                        <td>
                                                            <label class='control-label'>元使用</label>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                        <div class='row mb-3'>
                                            <label class='control-label col-md-3'>票券使用模式：</label>
                                            <div class='col-md-9'>
                                              <input type='radio' name='rdoStoreMode' value=0 v-model='StoreMode' @change="handleStoreModeChange">
                                              <label>指定品牌全門市</label>
                                              <input type='radio' name='rdoStoreMode' value=1 v-model='StoreMode' @change="handleStoreModeChange">
                                              <label>指定門市</label>
                                              <input type='radio' name='rdoStoreMode' value=2 v-model='StoreMode' @change="handleStoreModeChange" :disabled="TicketType.substr(0,3)=='G01'">
                                              <label>全品牌</label>
                                              <input hidden type="file" ref="fileInput" id="storeList" accept=".csv" @change="handleFileUpload()">
                                              <button type="button" class="btn btn-warning text-white ml-2" @click="handleResetStore()">清除已選門市</button>
                                              <div class="text-danger" style="padding: 0.3rem" v-if="v_StoreMode != ''">{{v_StoreMode}}</div>
                                              <div class='col-md-3'>
                                                <p class="text-primary cursor_add_store" @click="addStoreShow()">{{showStoreWord}}</p>
                                              </div>
                                            </div>
                                        </div>
                                        <div class='row mb-3' v-if="TicketType.substr(0,3)!=='G01'">
                                            <label class='control-label col-md-3'>票券使用品牌：</label>
                                            <div class='col-md-9'>
                                              <b-form-checkbox-group v-model="selectBrands" style="overflow: auto" stacked>
                                                <b-form-checkbox v-for="x in selectListBrands" :value="x.Code" :key="x.Code" :disabled="StoreMode==1||StoreMode==2">{{x.Text}}</b-form-checkbox>
                                              </b-form-checkbox-group>
                                              <div class="text-danger" style="padding: 0.3rem" v-if="v_BrandMsg != ''">{{v_BrandMsg}}</div>
                                            </div>
                                        </div>
                                        <div class='row mb-3'>
                                          <label class='control-label col-md-3'>票券使用時段：<br />(最多24，0~0為全時段)</label>
                                          <div class='col-md-2'>
                                            <validate tag="div">
                                              <input type='number' name='Input_UseStartAt' class='form-control' v-model='UseStartAt' min="0" max="24">
                                            </validate>
                                          </div>點
                                          <label class='control-label'>至</label>
                                          <div class='col-md-2'>
                                            <validate tag="div">
                                              <input type='number' name='Input_UseEndAt' class='form-control' v-model='UseEndAt' min="0" max="24">
                                            </validate>
                                          </div>點
                                          <div class="text-danger" style="padding: 0.3rem" v-if="v_UseTime != ''">{{v_UseTime}}</div>
                                        </div>
                                        <div class='row mb-3'>
                                            <label class='control-label col-md-3'>票券平假日使用設定：</label>
                                            <div class='col-md-9'>
                                              <input type='radio' name='rdoDayMode' value=0 v-model='DayMode'>
                                              <label>不分平假日</label>
                                              <input type='radio' name='rdoDayMode' value=1 v-model='DayMode'>
                                              <label>平日</label>
                                              <input type='radio' name='rdoDayMode' value=2 v-model='DayMode'>
                                              <label>假日</label>
                                            </div>
                                        </div>
                                        <div class="row mb-3">
                                          <label class='control-label col-md-3' for="memo">票券提示文字：</label>
                                          <validate tag="div" class="col-md-3">
                                            <input v-model="Memo" id="memo" name="Input_Memo" type="text" autofocus  class="form-control"/>
                                            <div class="text-danger" style="padding: 0.3rem" v-show="this.v_Memo != ''">{{this.v_Memo}}</div>
                                          </validate>
                                        </div>
                                        <div class="row mb-3">
                                          <label class='control-label col-md-3' for="pointSubsidy">票券補貼點數：</label>
                                          <div class='col-md-3'>
                                            <input type='number' name='Input_PointSubsidy' class='form-control' v-model='PointSubsidy' min="0">
                                          </div>
                                        </div>
                                        <div class='row mb-3'>
                                            <label class='control-label col-md-3'>備註條款：</label>
                                            <div class='col-md-9'>
                                              <vue-editor v-model="repl_content" :editor-toolbar="customToolbar"></vue-editor>
                                            </div>
                                        </div>
                                    </form>
                                </b-container>
                            </div>
                        </b-card>
                    </div>
                </div>
            </div>
            <b-modal size='lg' ref="addStore" hide-footer title="新增門市">
              <div class="row">
                <label class="control-label col-md-2 mt-2 text-right">地區</label>
                <div class="col-md-3">
                  <multiselect
                    id="city"
                    v-model="city"
                    :options="Array.from(citylist.keys())"
                    @input="cityChange"
                    :show-labels="false"
                    :multiple="false"
                    placeholder="請選擇"
                  >
                  <template slot="option" slot-scope="{ option }">
                    <span>
                      {{ option }}
                      <i class="fa fa-check" v-if="selectedCity.includes(option)" style="margin-left: 5px;"></i>
                    </span>
                  </template>
                  <span slot="noResult">查無資料</span>
                 </multiselect>
                </div>
                <label class="control-label col-md-1 mt-2 text-right">門市</label>
                <div class="col-md-5">
                  <multiselect v-model="store" :options="storelist" :multiple="false" :custom-label="nameWithLang" :placeholder="placeholderText" label="Name" track-by="Name" :show-labels="false" :disabled="isDisable">
                    <span slot="noResult">查無資料</span>
                  </multiselect>
                </div>
                <div>
                  <button type="button" class="btn btn-warning text-white" @click="handleAddStore()" :disabled="isDisable">新增</button>
                </div>
              </div>
              <div class="d-flex flex-row-reverse mt-3 mr-3">
                <div>
                  <i class="fa fa-question-circle" style="cursor: pointer;" @click="$refs.importFileDesc.show()"></i>
                  <button type="button" class="btn btn-warning text-white ml-2" @click="() => {this.$refs.fileInput.click()}">檔案匯入門市</button>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <div class="p-4 box-shadow" header="Form Elements">
                    <table id="mytable" class="table table-bordred table-striped mt-3 table-break">
                      <thead>
                          <tr>
                              <th width="10%">項次</th>
                              <th width="20%">地區</th>
                              <th width="30%">門市名稱</th>
                              <th width="30%">門市代碼</th>
                              <th width="10%">刪除</th>
                          </tr>
                          <tr v-for="v in showStoreList" :key="v.ID">
                              <td>{{v.Seq}}</td>
                              <td>{{v.City}}</td>
                              <td>{{v.Name}}</td>
                              <td>{{v.Code}}</td>
                              <td><button class='btn-circle btn-circle-ptc1' @click="handleDelStore(v.ID)"><span class='fas fa-trash-alt' title="刪除"></span></button></td>
                          </tr>
                      </thead>
                    </table>
                    <div>
                        <div class="row" style="padding: 0 1rem">
                            <b-pagination size="md" :total-rows="model1.totalrows" v-model="model1.currentPage" :per-page="model1.rows" @change="getAddStoreList"></b-pagination>
                            <label style="margin:8px">{{model1.startRowNum}}到{{model1.endRowNum}}，總共 {{model1.totalrows}}筆</label>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-modal>
            <!-- 匯入檔案說明 -->
            <b-modal ref="importFileDesc" hide-footer title="匯入檔說明">
              <pre class="mb-0" style="font-size:16px">
檔案格式
1. 僅限csv檔。
2. 檔名不限。
3. 可多次匯入不同檔案。
4. 重複門市將自動排除。

內容限制
1.僅需輸入門市代碼。
2.不可有空行(含最後一行)。
3.單次匯入上限為2000筆。
              </pre>
              <img src="/static/StoresImportSample.png" class="img-fluid"/>
            </b-modal>
        </vue-form>
    </div>
</template>

<script>
import Vue from 'vue'
import { getFunctionPermission } from '@/js/LoginUserFunction.js'
import ToggleButton from 'vue-js-toggle-button'
import axios from 'axios'
import { API_URL, fileUploadMaxSize } from '@/store/root.js'
import Multiselect from 'vue-multiselect'
// for 訊息視窗
import miniToastr from 'mini-toastr'
import { VueEditor } from 'vue2-editor'
miniToastr.init()
Vue.use(ToggleButton)
export default {
  components: {
    Multiselect,
    VueEditor
  },
  mounted () {
  },
  data () {
    return {
      formstate: {}, // 驗證用
      min_sdate: '', // 可選的最小日期
      min_edate: '', // 可選的最小日期
      max_date: '9999-12-31', // 可選的最大日期
      v_use_sdateMsg: '', // 檢核兌換期間
      v_SaleDate: '', // 檢核上架期間
      activeName: '', // 兌換活動
      AppType: '0', // APP分類
      TicketName: '', // 票券名稱
      TicketType: '', // 票券類別
      TicketPublished: 1,
      TicketPublishedDay: 30,
      TicketPublishedQty: 0, // 限量張數
      TicketLimitBuy: 1, // 限量購買限制
      TicketLimitBuyQty: 1, // 每日購買上限張數
      use_sdate: '', // 兌換期間
      use_edate: '', // 兌換期間
      sale_sdate: '', // 上架期間
      sale_edate: '', // 上架期間
      sale_stime: '', // 上架開始時間
      sale_etime: '', // 上架結束時間
      UseStartAt: 0, // 票券使用時段_開始(hh) 空白為全時段
      UseEndAt: 0, // 票券使用時段_結束(hh) 空白為全時段
      Memo: '', // 票券提示文字
      PointSubsidy: 0, // 票券補貼點數
      productsA: [],
      productsB: [],
      UseType: 1, // 使用管道
      StoreMode: 0, // 使用模式
      DayMode: 0,
      TicketRule: '', // 優惠規則
      product_A: '',
      product_B: '',
      useAmount: 0,
      Point: 0, // 兌換點數
      SaleMoney: 0, // 折抵/折扣
      dataUrl: undefined, // img
      addMoney: 0,
      ListAppType: [], // APP分類下拉
      ListTicketType: [], // 票券類別下拉
      saleDiscount: 0, // 銷售品折扣/金額
      v_AppType: '',
      v_sale_sdate: '',
      v_sale_edate: '',
      v_sale_stime: '',
      v_sale_etime: '',
      v_Product_A: '',
      v_Product_B: '',
      v_SaleDiscount: '',
      v_useAmount: '',
      v_PointMsg: '',
      v_SaleMoneyMsg: '',
      v_TicketPublishedQtyMsg: '',
      v_TicketPublishedDayMsg: '',
      v_TicketLimitBuyQtyMsg: '',
      v_dataUrlMsg: '',
      v_use_edateMsg: '',
      v_WeekMsg: '',
      v_UseTime: '',
      v_Memo: '',
      v_StoreMode: '',
      isFree: false,
      appSwap: true,
      allowTransfer: false,
      week: [],
      optionsWeek: [
        { text: '一', value: 1 },
        { text: '二', value: 2 },
        { text: '三', value: 3 },
        { text: '四', value: 4 },
        { text: '五', value: 5 },
        { text: '六', value: 6 },
        { text: '日', value: 0 }
      ],
      citylist: new Map(), // 地區類別下拉
      selectedCity: [],
      selectedCityList: new Map(),
      city: '', // 地區
      store: { ID: 0, Code: '', Name: '' }, // 門市
      storelist: [{ ID: 0, Code: '', Name: '' }],
      addStoreList: [],
      showStoreList: [],
      addStoreAmount: 0,
      showStoreWord: '新增排除門市',
      model1: {
        currentPage: 1,
        totalrows: 0,
        rows: 10,
        startRowNum: 0,
        endRowNum: 0
      },
      repl_content: '',
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        [{ size: ["small", false, "large", "huge"] }],
        ["bold", "italic", "underline", "strike"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" }
        ],
        ["blockquote"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ script: "sub" }, { script: "super" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ color: [] }, { background: [] }],
        ["link", "image"],
        ["clean"]
      ],
      selectListBrands: [{ ID: 0, Code: '', Text: '' }],
      selectBrands: [],
      v_BrandMsg: '',
      queryBrandsCode: 'MWD'
    }
  },
  created () {
    this.FunctionPermission = getFunctionPermission('F10') // 功能權限 帶入功能代碼
    if (this.FunctionPermission >= 2) {
      // 可選的最小日期
      var date = new Date()
      var year = date.getFullYear()
      var mon = date.getMonth() + 1
      var day = date.getDate()
      if (mon < 10) {
        mon = '0' + mon
      }
      if (day < 10) {
        day = '0' + day
      }
      this.min_sdate = year + '-' + mon + '-01'
      this.min_edate = year + '-' + mon + '-' + day
      this.load()
      this.getAllProductsA()
      this.getAllProductsB()
      this.getAddStoreList(1)
      this.querySelectListBrands()
    } else {
      if (this.FunctionPermission === 1) {
        this.$router.push({name: 'coupon_exchange_list'})
      } else {
        this.$router.push({name: 'name'})
      }
    }
  },
  methods: {
    checkSaleDiscount (check) {
      if (Number(this.UseType) !== 2 && (check || this.formstate.$submitted)) {
        this.v_SaleDiscount = ''
        this.v_Product_A = ''
        this.v_Product_B = ''

        // 買A送B
        if (this.TicketRule === '1' && (!this.product_A || !this.product_B)) {
          this.v_Product_B = '請輸入完整優惠規則'
        }
        if (this.TicketRule === '2' || this.TicketRule === '3' || this.TicketRule === '4') {
          if (!this.product_A) {
            this.v_Product_A = '請選擇品項'
          }
          // 商品折價
          if (this.TicketRule === '2') {
            if (Number(this.saleDiscount) <= 0 || Number.isInteger(Number(this.saleDiscount) === false)) {
              this.v_SaleDiscount = '請輸入1~999的整數'
            }
          }
          // 商品特價
          if (this.TicketRule === '3' && (Number(this.saleDiscount) < 0 || Number.isInteger(Number(this.saleDiscount) === false))) {
            this.v_SaleDiscount = '請輸入0~999的整數'
          }
          // 商品第二件N折
          if (this.TicketRule === '4' && (!this.saleDiscount || (parseFloat(this.saleDiscount) > 1 || parseFloat(this.saleDiscount) < 0.01 || this.saleDiscount.split('.').length > 2 || (this.saleDiscount.split('.').length >= 2 && this.saleDiscount.split('.')[1].length > 2)))) {
            this.v_SaleDiscount = '請輸入0.01~1的數值(小數最多兩位)'
          }
        }
      }
    },
    nameWithLang ({ Code, Name }) {
      return `${Code} — ${Name}`
    },
    validNumberLen (e, leng) {
      var value = e.target.value
      if (e.target.value.length > leng) {
        value = e.target.value.slice(0, leng)
      }
      return value
    },
    getAllProductsA () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/getallproducts/v1', {
        status: 1,
        hasDelete: false,
        hasExtra: false,
        hasCombo: false,
        brandCode: this.queryBrandsCode
      })
        .then((response) => {
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            this.productsA = response.data.data
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '商品資料讀取異常')
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '商品資料讀取異常')
        })
    },
    getAllProductsB () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/getallproducts/v1', {
        status: 1,
        hasDelete: false,
        hasExtra: true,
        hasCombo: false,
        brandCode: this.queryBrandsCode
      })
        .then((response) => {
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            this.productsB = response.data.data
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '商品資料讀取異常')
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '商品資料讀取異常')
        })
    },
    load () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/ticket/querydropdown')
        .then((response) => {
          if (response.data.result === '0000') {
            this.ListAppType = response.data.data.appcategory
            this.ListTicketType = response.data.data.poscategory
          } else {
            if (response.data.result === '0006') {
              this.$parent.logOut(false, true)
            } else {
              miniToastr.error(response.data.message, '錯誤訊息')
            }
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
          this.$parent.Loading = false
        })
    },
    updateValue: function (value) {
      this.ResetWeek()
      this.use_sdate = value
    },
    onSubmit: function () {

      // 檢核APP分類
      if (this.appSwap === true && this.AppType === '0') {
        this.v_AppType = '請選擇APP分類'
      } else {
        this.v_AppType = ''
      }
      // 檢核上架期間
      if (this.sale_sdate !== '' && this.sale_sdate < this.nowDate() && this.appSwap === true) {
        this.v_SaleDate = '起始日不可小於系統日'
      } else if (this.sale_sdate !== '' && this.sale_edate !== '' && this.sale_sdate > this.sale_edate) {
        this.v_SaleDate = '起始日不可大於結束日'
      } else {
        this.v_SaleDate = ''
      }
      if (this.sale_sdate === '') {
        this.v_sale_sdate = '請輸入正確的日期格式(起)'
      } else {
        this.v_sale_sdate = ''
      }
      if (this.sale_edate === '') {
        this.v_sale_edate = '請輸入正確的日期格式(迄)'
      } else {
        this.v_sale_edate = ''
      }
      if (this.sale_stime === '') {
        this.v_sale_stime = '請輸入上架時間(起)'
      } else {
        this.v_sale_stime = ''
      }
      if (this.sale_etime === '') {
        this.v_sale_etime = '請輸入上架時間(迄)'
      } else {
        this.v_sale_etime = ''
      }
      // 檢核兌換期間
      if (this.use_sdate !== '' && this.use_edate !== '' && this.use_sdate > this.use_edate) {
        this.v_use_edateMsg = '結束日不可小於起始日'
      } else {
        if (this.use_sdate !== '' && this.use_sdate < this.sale_sdate) {
          this.v_use_sdateMsg = '起始日不可小於上架日'
        } else {
          this.v_use_sdateMsg = ''
        }
        if (this.use_edate !== '' && this.use_edate < this.sale_edate) {
          this.v_use_edateMsg = '兌換期間不可小於下架結束日'
        } else {
          this.v_use_edateMsg = ''
        }
      }
      // 檢核使用模式
      const mode = Number(this.StoreMode)
      if (mode === 1 && this.addStoreAmount < 1) {
        this.v_StoreMode = '尚未選取使用門市'
      } else {
        this.v_StoreMode = ''
      }
      // 檢核使用期間
      this.UseStartAt = Number(this.UseStartAt)
      this.UseEndAt = Number(this.UseEndAt)
      if (this.UseStartAt > 24 || this.UseStartAt < 0 || this.UseEndAt > 24 || this.UseEndAt < 0) {
        this.v_UseTime = '請輸入0 至 24 之間數值'
      } else if (this.UseEndAt !== 0 && this.UseStartAt !== 0 && this.UseStartAt === this.UseEndAt) {
        this.v_UseTime = '起始時間不得等於結束時間'
      } else {
        this.v_UseTime = ''
      }

      if (Array.from(this.Memo.trim()).length > 8) {
        this.v_Memo = '輸入文字超過八個字'
      } else {
        this.v_Memo = ''
      }
      if (this.appSwap === true) {
        if (this.Point === '') {
          this.v_PointMsg = '請輸入兌換點數'
        } else if (this.Point !== '' && !(this.isFree && Number(this.TicketPublished) === 2) && (Number(this.Point) <= 0 || Number.isInteger(Number(this.Point)) === false)) {
          this.v_PointMsg = '值必須大於0且為整數'
        } else if (this.Point !== '' && (Number(this.Point) > 99999 || Number.isInteger(Number(this.Point)) === false)) {
          this.v_PointMsg = '值不可超過99,999且為整數'
        } else {
          this.v_PointMsg = ''
        }
      } else {
        this.v_PointMsg = ''
      }

      this.v_Product_A = ''
      this.v_Product_B = ''
      this.v_SaleDiscount = ''
      this.v_useAmount = ''
      if (this.TicketType.substr(0, 3) !== 'G01') {
        if (this.SaleMoney !== '' && this.TicketType.substr(0, 3) === 'A01' && (Number(this.SaleMoney) < 1 || Number(this.SaleMoney) > 9999 || Number.isInteger(Number(this.SaleMoney)) === false)) {
          this.v_SaleMoneyMsg = '請輸入1~9,999的整數'
        } else if (this.SaleMoney !== '' && this.TicketType.substr(0, 3) === 'C01' && (parseFloat(this.SaleMoney) > 1 || parseFloat(this.SaleMoney) < 0.01 || this.SaleMoney.split('.').length > 2 || (this.SaleMoney.split('.').length >= 2 && this.SaleMoney.split('.')[1].length > 2))) {
          this.v_SaleMoneyMsg = '請輸入0.01~1的數值(小數最多兩位)'
        } else {
          this.v_SaleMoneyMsg = ''
        }
        if (Number(this.UseType) !== 2 && this.TicketType !== 'A01BC') {
          // 滿額使用
          if (Number(this.useAmount) <= 0 || Number.isInteger(Number(this.useAmount)) === false) {
            this.v_useAmount = '請輸入1~9,999的整數'
          }
        }
      } else {
        this.checkSaleDiscount(true)
      }
      if (Number(this.TicketPublished) === 2 && this.TicketPublishedQty !== '' && (Number(this.TicketPublishedQty) <= 0 || Number.isInteger(Number(this.TicketPublishedQty)) === false)) {
        this.v_TicketPublishedQtyMsg = '值必須大於0且為整數'
      } else if (Number(this.TicketPublished) === 2 && this.TicketPublishedQty !== '' && (Number(this.TicketPublishedQty) > 99999 || Number.isInteger(Number(this.TicketPublishedQty)) === false)) {
        this.v_TicketPublishedQtyMsg = '值不可超過99,999且為整數'
      } else {
        this.v_TicketPublishedQtyMsg = ''
      }
      if (Number(this.TicketPublished) === 1 && this.TicketPublishedDay !== '' && (Number(this.TicketPublishedDay) <= 0 || Number.isInteger(Number(this.TicketPublishedDay)) === false)) {
        this.v_TicketPublishedDayMsg = '值必須大於0且為整數'
      } else if (Number(this.TicketPublished) === 1 && this.TicketPublishedDay !== '' && (Number(this.TicketPublishedDay) > 99999 || Number.isInteger(Number(this.TicketPublishedDay)) === false)) {
        this.v_TicketPublishedDayMsg = '值不可超過99,999且為整數'
      } else {
        this.v_TicketPublishedDayMsg = ''
      }
      if (Number(this.TicketPublished) === 2 && Number(this.TicketLimitBuy) === 2 && this.TicketLimitBuyQty !== '') {
        if (Number(this.TicketLimitBuyQty) <= 0 || Number.isInteger(Number(this.TicketLimitBuyQty)) === false) {
          this.v_TicketLimitBuyQtyMsg = '值必須大於0且為整數'
        } else if (Number(this.TicketLimitBuyQty) > 99999 || Number.isInteger(Number(this.TicketLimitBuyQty)) === false) {
          this.v_TicketLimitBuyQtyMsg = '值不可超過99,999且為整數'
        } else if (this.TicketPublishedQty !== '' && Number(this.TicketLimitBuyQty) > Number(this.TicketPublishedQty)) {
          this.v_TicketLimitBuyQtyMsg = '限購張數不可大於販售總數'
        } else {
          this.v_TicketLimitBuyQtyMsg = ''
        }
      } else {
        this.v_TicketLimitBuyQtyMsg = ''
      }
      if (this.dataUrl === undefined) {
        this.v_dataUrlMsg = '請選擇上傳圖片'
      } else {
        this.v_dataUrlMsg = ''
      }
      if (this.appSwap === true && (!this.week || this.week.length <= 0)) {
        this.v_WeekMsg = '請至少勾選一個週期'
      } else if (this.appSwap === false) {
        this.v_WeekMsg = ''
      } else {
        if (!this.checkWeek()) {
          this.v_WeekMsg = '勾選的週期不在上架區間中，請重新確認'
        } else {
          this.v_WeekMsg = ''
        }
      }

      if (Number(this.StoreMode)=== 0 && this.selectBrands.length == 0 && this.TicketType.substr(0,3)!=='G01') {
        this.v_BrandMsg = '請勾選品牌'
      } else {
        this.v_BrandMsg = ''
      }

      if (this.formstate.$invalid || this.v_dataUrlMsg !== '' || this.v_SaleDate !== '' || this.v_use_sdateMsg !== '' || this.v_use_edateMsg !== '' || this.v_PointMsg !== '' ||
          this.v_SaleMoneyMsg !== '' || this.v_TicketPublishedQtyMsg !== '' || this.v_TicketPublishedDayMsg !== '' || this.v_WeekMsg !== '' || this.v_TicketLimitBuyQtyMsg !== '' ||
          this.v_Product_A !== '' || this.v_Product_B !== '' || this.v_SaleDiscount !== '' || this.v_useAmount !== '' || this.v_AppType !== '' || this.v_sale_sdate !== '' ||
          this.v_sale_edate !== '' || this.v_UseTime !== '' || this.v_Memo !== '' || this.v_StoreMode !== '' || this.v_sale_stime !== '' || this.v_sale_etime !== ''|| this.v_BrandMsg !== '') {
        this.$parent.verificationErrMsg()
      } else {
        this.add()
      }
    },
    ResetWeek: function () {
      if (this.sale_sdate !== '' && this.sale_edate !== '' && this.sale_sdate <= this.sale_edate) {
        var diffDay = this.DateDiff(this.sale_edate, this.sale_sdate)
        if (diffDay < 7) {
          this.week = []
          for (let index = 0; index <= diffDay; index++) {
            var checkDate = new Date(this.sale_sdate)
            this.week.push(new Date(checkDate.setDate(checkDate.getDate() + index)).getDay())
          }
        } else {
          this.week = [0, 1, 2, 3, 4, 5, 6]
        }
      }
    },
    checkWeek: function () {
      if (!this.v_SaleDate) {
        var diffDay = this.DateDiff(this.sale_edate, this.sale_sdate)
        if (diffDay < 7) {
          var nowWeeks = ''

          for (let index = 0; index <= diffDay; index++) {
            var checkDate = new Date(this.sale_sdate)
            nowWeeks += new Date(checkDate.setDate(checkDate.getDate() + index)).getDay()
          }

          for (let index = 0; index < this.week.length; index++) {
            if (nowWeeks.indexOf(this.week[index]) < 0) {
              return false
            }
          }
        }
      }
      return true
    },
    DateDiff: function (sDate1, sDate2) {
      var oDate1, oDate2, iDays
      oDate1 = new Date(sDate1)
      oDate2 = new Date(sDate2)
      iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24)
      return iDays
    },
    onChangeFree: function () {
      if (this.isFree === true) {
        this.Point = 0
      }
    },
    onChangeAppSwap: function () {
      if (this.appSwap === false) {
        this.AppType = 0
        this.TicketPublished = 1
        this.sale_sdate = ''
        this.sale_edate = ''
        this.week = []
        this.Point = 0
      }
    },
    onChangeTicketType: function () {
      if (this.TicketType.substr(0, 3) === 'G01') {
        this.TicketRule = ''
      } else {
        this.TicketRule = '5'
      }
    },
    add () {
      var limitQty = 0
      var limitType = 0
      var days = Number(this.TicketPublishedDay)
      var amount = Number(this.TicketPublishedQty)
      var applicablestartat = ''
      var applicableendat = ''
      var free = false
      if (this.TicketPublished === '1') {
        amount = 0
      } else if (this.TicketPublished === '2') {
        days = 0
        applicablestartat = this.use_sdate.replace(/-/g, '')
        applicableendat = this.use_edate.replace(/-/g, '')
        free = this.isFree
        limitType = Number(this.TicketLimitBuy)

        if (limitType === 1) {
          limitQty = 1
        } else if (limitType === 2) {
          limitQty = Number(this.TicketLimitBuyQty)
        }
      }

      var discount = 0
      var text = ''
      if (this.TicketType.substr(0, 3) === 'G01') {
        text = this.activeName
      } else if (this.TicketType.substr(0, 3) === 'A01') {
        discount = Number(this.SaleMoney)
      } else if (this.TicketType.substr(0, 3) === 'C01') {
        discount = parseFloat(this.SaleMoney)
      }

      var rule = 0
      var buyItem = ''
      var buyDisc = 0
      var saleItem = ''
      var saleDisc = 0
      var useAmo = 0
      if (Number(this.UseType) !== 2) {
        if (this.TicketType.substr(0, 3) === 'G01') {
          rule = Number(this.TicketRule)
          if (rule === 1) {
            buyItem = this.product_A.Code
            saleItem = this.product_B.Code
          } else if (rule === 2 || rule === 3) {
            buyItem = this.product_A.Code
            buyDisc = Number(this.saleDiscount)
          } else if (rule === 4) {
            buyItem = this.product_A.Code
            saleItem = this.product_A.Code
            saleDisc = parseFloat(this.saleDiscount)
          }
        } else {
          rule = 5
          useAmo = Number(this.useAmount)
        }
      }
      if (this.TicketType.substr(0,3)=='G01'){
        this.selectBrands = [this.queryBrandsCode]
      }
      var arrAll = {
        appcategoryid: this.AppType,
        name: this.TicketName,
        poscategorycode: this.TicketType,
        published: Number(this.TicketPublished),
        days: days,
        amount: amount,
        enabledat: this.sale_sdate.replace(/-/g, ''),
        disabledat: this.sale_edate.replace(/-/g, ''),
        enabledattime: this.sale_stime,
        disabledattime: this.sale_etime,
        applicablestartat: applicablestartat,
        applicableendat: applicableendat,
        bonus: Number(this.Point),
        discount: discount,
        text: text,
        comment: this.repl_content,
        free: free,
        week: this.week.toString(),
        limitType: limitType,
        limitQty: limitQty,
        useType: Number(this.UseType),
        rule: rule,
        buyCode: buyItem,
        buyDiscount: buyDisc,
        saleCode: saleItem,
        saleDiscount: saleDisc,
        useAmount: useAmo,
        appSwap: this.appSwap,
        allowTransfer: this.allowTransfer,
        storeMode: Number(this.StoreMode),
        storeList: (this.addStoreList.length > 0) ? this.addStoreList : [],
        useStartAt: (!this.UseStartAt && !this.UseEndAt) ? '' : (this.UseStartAt.toString().padStart(2, '0') + ':00'),
        useEndAt: (!this.UseStartAt && !this.UseEndAt) ? '' : (this.UseEndAt.toString().padStart(2, '0') + ':00'),
        dayMode: Number(this.DayMode),
        memo: this.Memo,
        pointSubsidy: Number(this.PointSubsidy),
        brandCodes: this.selectBrands
      }
      let formData = new FormData()
      formData.append('image', this.file)
      formData.append('data', JSON.stringify(arrAll))

      var config = {
        headers: {
          'Content-Type': undefined
        }
      }
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/ticket/create', formData, config)
        .then((response) => {
          if (response.data.result === '0000') {
            miniToastr.success('新增成功')
            this.$router.push({ name: 'coupon_exchange_list', params: { queryTab0: this.$route.params.queryTab0, querySaleNow: this.$route.params.querySaleNow, querySaleSchedule: this.$route.params.querySaleSchedule, queryTab1: this.$route.params.queryTab1, queryTab2: this.$route.params.queryTab2, collapse: this.$route.params.collapse, modelTab: 0 } })
          } else {
            if (response.data.result === '0006') {
              this.$parent.logOut(false, true)
            } else {
              miniToastr.error(response.data.message, '錯誤訊息')
            }
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
          this.$parent.Loading = false
        })
    },
    handleFileChange (e) {
      let inputDOM = this.$refs.inputer
      this.file = inputDOM.files[0]
      this.$emit('input', this.file)
      this.fileName = this.file.name
      if (!this.imgPreview(this.file)) {
        this.$refs.inputer.value = ''
        this.dataUrl = undefined
      }
    },
    imgPreview (file) {
      var rtn = false
      let self = this
      if (!file || !window.FileReader) return

      if (/^image/.test(file.type)) {
        if (file.size > fileUploadMaxSize) {
          miniToastr.error('圖檔大小不可超過 5MB')
        } else {
          let reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onloadend = function () {
            self.dataUrl = this.result
          }
          rtn = true
        }
      } else {
        miniToastr.error('請選擇正確圖檔')
      }
      return rtn
    },
    nowDate: function () {
      var time = new Date()
      var year = time.getFullYear()
      var month = time.getMonth() + 1
      var day = time.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (day >= 0 && day <= 9) {
        day = '0' + day
      }
      return year + '-' + month + '-' + day
    },
    getpost () {
      this.selectedCity= []
      this.citylist= new Map()
      this.city=''
      this.store = ''
      if (this.TicketType.substr(0,3)=='G01'){
        this.selectBrands = [this.queryBrandsCode]
      }
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/getallstoresTowLevel/v1', {
        brandCode: this.selectBrands
      })
        .then((response) => {
          if (response.data.result === '0000') {
            const mapCityList = new Map()
            const mapSelected = new Map()
            if (response.data.data != null) {
              response.data.data.forEach(item => {
                mapCityList.set(item.City, item.Stores.map(store => {
                  store.City = item.City
                  return store
                }))
                mapSelected.set(item.City, [])
              })
              this.citylist = mapCityList
              this.selectedCityList = mapSelected
              this.cityChange()
            }
            this.$store.commit('TOKEN', response.data.jwt)
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料讀取異常1')
            console.log(response.data.message)
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          console.log('CATCH')
          console.log(error)
          miniToastr.error(error.message, '資料讀取異常2')
          this.$parent.Loading = false
        })
    },
    cityChange () {
      var city = this.city
      var plist = []
      if (this.citylist.has(city)) {
        this.citylist.get(city).sort((a, b) => a.ID - b.ID)
        plist = [...this.citylist.get(city)]
      }
      if (city.trim() !== '' && plist.length !== 0) {
        plist.unshift({
          Code: 'ALL',
          ID: 0,
          Name: city + '全門市'
        })
      }
      this.updateSelectedCity()
      this.storelist = plist
      this.store = ''
    },
    handleAddStore () {
      if (this.store) {
        if (this.store.ID === 0) { // 新增該地區全門市
          // 新增至儲存的門市列表
          this.addStoreList = [...this.citylist.get(this.city), ...this.addStoreList]
          // 更新已選擇門市列表
          this.selectedCityList.set(this.city, [...this.selectedCityList.get(this.city), ...this.citylist.get(this.city)])
          // 更新門市列表為空
          this.citylist.set(this.city, [])
        } else { // 新增該地區單一門市
          let storeObj = {...this.store} // copy object
          delete storeObj.Seq // delete sequence number
          // 新增至儲存的門市列表
          this.addStoreList.unshift(storeObj)
          // 更新門市列表刪除所選選項
          const newArr = this.citylist.get(this.city).filter(store => store.ID !== this.store.ID)
          this.citylist.set(this.city, newArr)
          // 更新已選擇門市列表新增所選選項
          this.selectedCityList.get(this.city).push(storeObj)
        }
      }
      this.cityChange()
      this.getAddStoreList(1)
    },
    handleDelStore (storeID) {
      this.addStoreList.forEach((item, index) => {
        if (item.ID === storeID) {
          this.addStoreList.splice(index, 1)
        }
      })
      this.selectedCityList.forEach((stores, city) => {
        if (stores.length > 0) {
          stores.forEach((store, storeIndex) => {
            if (store.ID === storeID) {
              this.citylist.get(city).push({...this.selectedCityList.get(city).splice(storeIndex, 1)[0]})
            }
          })
        }
      })
      this.cityChange()
      this.getAddStoreList(this.model1.currentPage)
    },
    refreshAddStoreAmount () {
      this.addStoreAmount = this.addStoreList.length
      const mode = Number(this.StoreMode)
      if (this.addStoreAmount > 0) {
        if (mode !== 1) {
          this.showStoreWord = `已排除${this.selectedCity.length}個地區${this.addStoreAmount}間門市`
        } else if (mode === 1) {
          this.v_StoreMode = ''
          this.showStoreWord = `已新增${this.selectedCity.length}個地區${this.addStoreAmount}間門市`
        }
      } else {
        if (mode !== 1) {
          this.showStoreWord = '新增排除門市'
        } else if (mode === 1) {
          this.showStoreWord = '新增使用門市'
        }
      }
    },
    getAddStoreList (currentPage) {
      this.refreshAddStoreAmount()
      this.model1.currentPage = currentPage
      this.model1.totalrows = this.addStoreAmount
      const startIndex = (this.model1.currentPage - 1) * this.model1.rows
      const endIndex = this.model1.currentPage * this.model1.rows
      if (!this.addStoreList[startIndex] && this.addStoreAmount > 0) {
        this.getAddStoreList(currentPage - 1)
        return
      }
      let storesArray
      if (endIndex < this.addStoreAmount) {
        storesArray = this.addStoreList.slice(startIndex, endIndex)
      } else {
        storesArray = this.addStoreList.slice(startIndex)
      }
      this.showStoreList = JSON.parse(JSON.stringify(storesArray)) // 複製物件否則底下Seq將影響原陣列內部之物件
      this.showStoreList.forEach((item, index) => {
        item.Seq = startIndex + index + 1
      })
      this.model1.startRowNum = (this.addStoreAmount === 0) ? 0 : startIndex + 1
      this.model1.endRowNum = (this.addStoreAmount === 0) ? 0 : (this.addStoreAmount < endIndex) ? this.addStoreAmount : endIndex
    },
    handleStoreModeChange () {
      this.selectBrands = []
      this.addStoreList = [] // reset the list
      this.getpost()
      this.getAddStoreList(1)
      const mode = Number(this.StoreMode)
      if (mode !== 1) {
        this.showStoreWord = '新增排除門市'
      } else if (mode === 1) {
        this.showStoreWord = '新增使用門市'
      }
    },
    handleResetStore () {
      this.handleStoreModeChange()
    },
    handleFileUpload: async function () {
      let invalid = false
      const file = this.$refs.fileInput.files[0]
      if (file.size > 1024 * 1024 * 1 || file.name.slice(-4) !== '.csv') {
        miniToastr.error('請確認門市清單')
        invalid = true
      }
      const reader = new FileReader()
      reader.readAsText(file)
      const frdDoneEvent = await new Promise(resolve => { reader.onload = resolve })
      // 過濾換行符號、空白、及空的元素後並篩掉重複數值
      const uploadStores = [...new Set(frdDoneEvent.target.result.split('\n').map(item => item.trim()).filter(Boolean))]
      const maxStoreUploadAmount = 2000 // 上限
      if (uploadStores.length > maxStoreUploadAmount) {
        miniToastr.error('請確認門市清單格式')
        invalid = true
      }

      // Add store
      this.citylist.forEach((stores, city) => {
        stores.forEach((store) => {
          if (uploadStores.includes(store.Code)) {
            let storeObj = {...store} // copy object
            this.addStoreList.unshift(storeObj)
            this.selectedCityList.get(city).push(storeObj)
          }
        })
        this.citylist.set(city, this.citylist.get(city).filter(store => !uploadStores.includes(store.Code)))
      })

      if (invalid) {
        miniToastr.error('檔案解析失敗')
      } else {
        miniToastr.success('檔案解析成功')
        this.cityChange()
        this.getAddStoreList(1)
      }
      // 清空檔案所以允許多次上傳
      document.getElementById('storeList').value = null
    },
    updateSelectedCity () {
      if (this.addStoreList.length > 0) {
        this.selectedCity = [...new Set(this.addStoreList.map(store => store.City))]
      } else {
        this.selectedCity = []
      }
    },
    querySelectListBrands() {
      //品牌下拉選單
      axios
        .post(API_URL + "/web/brands/v1", {
          all: false,
          order: false
        })
        .then(response => {
          this.selectListBrands = response.data.data;
          this.$parent.Loading = false;
        })
        .catch(error => {
          this.selectListBrands = [];
          this.$parent.Loading = false;
          miniToastr.error(error, "資料讀取異常");
          console.log(error);
        });
    },
    addStoreShow () {
      if (this.TicketType.substr(0,3)!=='G01' && Number(this.StoreMode)=== 0 && this.selectBrands.length == 0) {
        this.v_BrandMsg = '請勾選品牌'
        return
      } else {
        this.v_BrandMsg = ''
      }
      this.$refs.addStore.show()
/*       this.modalSelectListBrands = []
      for (let index = 0; index < this.selectListBrands.length; index++) {
        if (this.selectBrands.indexOf(this.selectListBrands[index].Code)>=0) {
          this.modalSelectListBrands.push({Code: this.selectListBrands[index].Code, Text: this.selectListBrands[index].Text})
          if (this.modalSelectListBrands.length==1) {
            this.queryBrandsCode = this.selectListBrands[index].Code
          }
        }
      } */
      this.getpost()
    },
    onTicketTypeChange () {
      this.v_SaleMoneyMsg='';
      if (this.TicketType.substr(0,3)=='G01' && this.StoreMode==2){
        this.StoreMode=0
      }
      if (this.TicketType.substr(0,3)=='C01'){
        this.UseType=3
      } else {
        this.UseType=1
      }
    },
    onQueryBrandsCodeChange () {
      this.getAllProductsA()
      this.getAllProductsB()
      this.product_A=''
      this.product_B=''
      this.addStoreList=[]
      this.getAddStoreList(1)
    }
  },
  computed: {
    placeholderText () {
      return (!this.city || this.storelist.length) ? '請選擇' : '已全數選擇完畢'
    },
    isDisable () {
      return (!this.city || this.storelist.length === 0)
    }
  }
}
</script>

<style scoped>
.upload_block {
  position: relative;
  width: 200px;
  height: 140px;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  background: #f1f1f1;
  border: 3px dashed #d6d4d4;
}
.upload_input {
  display: none;
}
.upload_img {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 2;
}
.upload_icon {
  font-weight: bold;
  font-size: 200%;
  position: absolute;
  z-index: 1;
  left: 0;
  width: 100%;
  top: 35%;
}
.cursor_add_store {
  cursor: pointer;
}
.cursor_add_store:hover {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/pages/coupon/exchange/Add.vue